import sectionItemsGrid04Css from '../css-snippets/section-items-grid-04';

const html = `
<style>${sectionItemsGrid04Css}</style>
<div
  id="items-grid-section-unique-id"
  data-id="unique-id"
  class="items-grid-wrapper"
  data-attribute="items-grid-wrapper"
  data-background-color="#f2f2f2"
  data-text-color="#000000"
  data-card-background-color="#f2f2f2"
  data-card-text-color="#000000"
  data-top-padding="true"
  data-bottom-padding="true"
  data-background-image="false"
  data-card-border-radius="0"
  data-item-image-width-desktop="110"
  data-item-image-width-mobile="110"
  data-show-number="false"
  data-items-grid-list-width="85"
  data-image-show="false"
  data-image-position="left"
  style="
    --background-color: #f2f2f2;
    --text-color: #000000;
    --card-text-color: #000000;
    --card-background-color: #f2f2f2;
    --card-border-radius: 0px;
    --item-image-width-desktop: 110px;
    --item-image-width-mobile: 110px;
     --items-grid-list-width: 85%;
  "
>
  <div
    data-attribute="items-grid-content"
    class="items-grid-content container"
    data-container-full-width="false"
  >
    <div data-attribute="title-content" class="items-grid-header">
      <h2 style="text-align: center">
        <strong>12 Amazing Health Benefits of Lignosus</strong>
      </h2>
    </div>
    <div class="items-grid-list-wrapper">
      <div class="items-grid-list-image" data-attribute="items-grid-image">
        <img
          data-attribute="items-grid-image-inner"
          src="https://cdn.skyfastimg.com/images/2026/04/09/image-69d77c0715765c280f672947.png?w=500&h=50&q=80"
          alt="img"
        />  
      </div>
      <div
        data-attribute="items-grid-list"
        class="items-grid-list"
        data-items-per-row-mobile="1"
        data-items-per-row-desktop="1"
        style="
          --items-per-row-mobile: 1;
          --items-per-row-desktop: 1;
        "
      >
        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            1.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/01/image-69ccbfaaec071dd3b7cd743a.png?w=500&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
            <h2><strong>#1 Relieves Cough & Phlegm*</strong></h2>
            <p>
              Soothes wheezing and coughing and helps loosen phlegm to make
              coughs more productive.
            </p>
          </div>
        </div>

        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            2.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/01/image-69ccbfc4d32058017579a753.png?w=500&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
            <h2><strong>#2 Improves Breathing*</strong></h2>
            <p>
              Helps to open and clear airways to improve breathing capabilities.
            </p>
          </div>
        </div>

        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            3.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/01/image-69ccbfd26bbcb3b36b5d631f.png?w=500&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
            <h2><strong>#3 Supports Healthy Mucus Production*</strong></h2>
            <p>
              Minimizes irritation in the respiratory tract to support balanced
              mucus production.
            </p>
          </div>
        </div>

        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            4.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/01/image-69ccbfe37d30a5508092524f.png?w=500&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
            <h2><strong>#4 Soothes Respiratory Inflammation*</strong></h2>
            <p>
              Helps to block specific proteins that may trigger abnormal
              inflammatory responses in the respiratory tract.
            </p>
          </div>
        </div>

        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            5.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/01/image-69ccbff1e4d1e95933d61b4e.png?w=500&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
            <h2><strong>#5 Cleanses & Detoxes Lungs*</strong></h2>
            <p>
              Helps to clear mucus, toxins, harmful pollutants, and impurities
              from the lungs.
            </p>
          </div>
        </div>

        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            6.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/01/image-69ccbffea93a08ed8b399a3a.png?w=500&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
            <h2><strong>#6 Relieves Nasal Congestion*</strong></h2>
            <p>
              Aids to loosen nasal and sinus congestion by helping break down
              mucus buildup. Improves lung capacity and oxygen flow to relieve
              chest congestion.
            </p>
          </div>
        </div>

        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            7.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/01/image-69ccc00b38969e6a8242adf8.png?w=500&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
            <h2><strong>#7 Natural COPD Support*</strong></h2>
            <p>
              Helps to reduce airway inflammation, balance the immune response,
              and protect the respiratory system, providing potential relief for
              asthma symptoms.
            </p>
          </div>
        </div>

        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            8.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/01/image-69ccc018734cb368ea88fc44.png?w=500&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
            <h2><strong>#8 Natural COPD Support*</strong></h2>
            <p>
              Acts as a natural support for COPD by reducing inflammation,
              providing antioxidants. modulating the immune system, and
              promoting respiratory health.
            </p>
          </div>
        </div>

        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            9.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/01/image-69ccc025c85afd25c0a203a6.png?w=500&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
            <h2><strong>#9 Long Term Smokers Immunity Boost*</strong></h2>
            <p>
              Helps to ease smoker's cough. Improves lung functions to fight
              against inhaled smoke. However, quitting smoking is the best way
              to avoid long-term damage to your lungs.
            </p>
          </div>
        </div>

        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            10.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/01/image-69ccc03298cfce27e8c40353.png?w=500&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
            <h2><strong>#10 Enhances Respiratory Wellness*</strong></h2>
            <p>
              Rich in antioxidants that rejuvenate cellular damage in the
              respiratory systems, supporting lung, sinus, and bronchial health.
            </p>
          </div>
        </div>

        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            11.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/01/image-69ccc03c516a716c11ce1a0f.png?w=500&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
            <h2><strong>#11 Supports Healthy Immune System*</strong></h2>
            <p>
              Tiger Milk Mushroom's anti-microbial properties help to boost lung
              immunity against allergens.
            </p>
          </div>
        </div>

        <div data-attribute="items-grid-item" class="items-grid-item">
          <div class="items-grid-item-number" data-attribute="number-item">
            12.
          </div>
          <div class="items-grid-item-image">
            <img
              data-attribute="image-item"
              src="https://cdn.skyfastimg.com/images/2026/04/01/image-69ccc048c75e4491a69fce35.png?w=500&h=50&q=80"
              alt="img"
            />
          </div>
          <div data-attribute="text-item" class="items-grid-item-text">
            <h2><strong>#12 Relieves Sinus Symptoms*</strong></h2>
            <p>
              The anti-inflammatory properties of Tiger Milk Mushroom aid in the
              prevention and alleviation of sinus inflammation.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
